import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidateSocialGraph } from "Api/Mutations/Social/invalidateSocialGraph";
import { handleAvailabilityKeys } from "Api/Queries/Social/useHandleAvailabilityQuery";
import { userInfoKeys } from "Auth/Api/Queries/useUserInfoQuery";
import { postSocialChatTerminate } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
};

/**
 * Terminates the active persona's Chat contract ("Ukončit Chat"): v1 clears the handle, which
 * takes every chat and social feature with it. Idempotent on the server. The handle is served
 * through user-info and sits in every cached profile/search result, so the same families as the
 * handle mutation are reconciled.
 */
export const useTerminateChatContractMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(() =>
      postSocialChatTerminate(),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: handleAvailabilityKeys.all });
      queryClient.invalidateQueries({ queryKey: userInfoKeys.all });
      invalidateSocialGraph(queryClient);
      onSuccess?.();
    },
    onError: () => {
      onError?.();
    },
  });
};
